import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import { connect, useDispatch } from 'react-redux';
import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { getArticle, getArticles, postArticle, putArticle } from '../../../store/actions/article/article_action';
import { REACT_ROUTES } from '../../../constants/react_routes';
import history from '../../../services/history';
import TextInput from '../../ui_components/text_input';
import { useSnackbar } from 'notistack';
import { roundNumber } from '../../../utils/helper_functions';
import { ARTICLE_TAB } from '../../../constants/constants';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    typography: {
		margin: theme.spacing(3, 0, 2)
    },
    form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
        '& p': {
            color: '#bf1650',
            '&::before': {
                display: 'inline',
                content: '"⚠ "'
            }
        }
	}
}));

const Article = ({ articles }) => {
    const { uuid } = useParams();
    const { container, typography, form } = useStyles();
    const { control, handleSubmit, reset, formState: { errors } } = useForm();
    const dispatch = useDispatch();

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        uuid && (async () => {
            const article = await getArticle(uuid);
            reset({...article, price: roundNumber(article?.price) });
        })();
        !articles.collection.length && dispatch(getArticles());
    }, [uuid]);

    const onSubmit = (data) => {
        data.duration = data?.duration && parseInt(data.duration);
        if (uuid) {
            enqueueSnackbar(
                'Uspešno sačuvana usluga', {
                variant: 'success'
            });
            return dispatch(putArticle(uuid, data));
        }
        enqueueSnackbar(
            'Uspešno dodata usluga', {
            variant: 'success'
        });
        return dispatch(postArticle(data));
    }

    const handleClickBackToTabs = () => {
        history.push(REACT_ROUTES.ARTICLE_TABS, { selectedTab: ARTICLE_TAB });
    }

    return (
        <Container className={container}>
            <Typography align="center" variant="h4" className={typography}>Usluga</Typography>
            <Grid container justify="center" spacing={3}>
                <Grid item>
                    <Button
                        color="primary"
                        size="small"
                        variant="contained"
                        onClick={handleSubmit(onSubmit)}
                        type="button"
                    >
                        Sačuvaj
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleClickBackToTabs}
                    >
                        Nazad
                    </Button>
                </Grid>
            </Grid>
            <form className={form}>
                <Grid container justify="center" spacing={3}>
                    <Grid item xs={8}>
                        <TextInput
                            control={control}
                            name="name"
                            label="Naziv"
                            rules={{ required: 'Unesite naziv' }}
                        />
                        <ErrorMessage errors={errors} name="name" as="p" />
                    </Grid>
                    <Grid item xs={8}>
                        <TextInput
                            control={control}
                            name="price"
                            label="Cena"
                            type="number"
                            rules={{ required: 'Unesite cenu' }}
                        />
                        <ErrorMessage errors={errors} name="price" as="p" />
                    </Grid>
                    <Grid item xs={8}>
                        <TextInput
                            control={control}
                            name="duration"
                            type="number"
                            label="Dužina trajanja (u minutima)"
                        />
                        <ErrorMessage errors={errors} name="duration" as="p" />
                    </Grid>
                </Grid>
            </form>
        </Container>
    )
}

Article.propTypes = {
    articles: PropTypes.object
}

const mapStateToProps = (state) => ({
    articles: state.articles
});

export default connect(mapStateToProps)(Article);
